import { ArticleType } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';

export const AllowedArticleTypesOptions = Object.values(ArticleType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
